export default "__VITE_ASSET__De8z$VgK__"